import { ScrollToTopButton } from "../components/ScrollToTopButton/ScrollToTopButton";
// import { HeaderTwo } from "../components/Headers/HeaderTwo";
// import { FooterTwo } from "../components/Footers/FooterTwo";
// import { HeaderFour } from "../components/Headers/HeaderFour";
// import { FooterOne } from "../components/Footers/FooterOne";
// import { HeaderFive } from "../components/Headers/HeaderFive";
// import { HeaderOne } from "../components/Headers/HeaderOne";
// import { HeaderSix } from "../components/Headers/HeaderSix";
import { HeaderThree } from "../components/Headers/HeaderThree";
import { FooterThree } from "../components/Footers/FooterThree";
import { Breadcrumb } from "../components/Breadcrumb/Breadcrumb";

export const Layout = ({ children, header, footer, breadcrumb, title }) => {
  return (
    <>
      {/* Scroll-top  */}
      <ScrollToTopButton />

      {/* header */}
      <HeaderThree />

      {/* breadcrumb */}
      {breadcrumb && <Breadcrumb text={breadcrumb} title={title} />}

      {/* children */}
      <main className="fix">{children}</main>

      {/* footer */}
      <FooterThree />
    </>
  );
};
